module.exports = __webpack_public_path__ + "img/img3.db64ead6.png";